// extracted by mini-css-extract-plugin
export default {"container":"Menu_container__OKuFY","focus":"Menu_focus__GfKub","active":"Menu_active__Xrso-","dot":"Menu_dot__IXaE4"};